import classNames from "classnames"
import Image from "next/image"
import { ImagePlaceholders } from "constants/images"
import { MapControlIconSizeClasses } from "./constants"

export type ImageFileIconProps = {
    id?: string
    imageFilePath?: string
    title?: string
    containerClasses?: string
    // sizing for images is weird, so we will use this differently than svg icons
    iconSize?: string
    className?: string
}

/**
 * base component that displays a given image file wrapped in some nice css
 * primarily intended to be used with MapControl icons, so the defaults are set to that
 *
 * @returns
 */
export const ImageFileIcon = ({
    id,
    containerClasses,
    imageFilePath,
    title,
    iconSize = MapControlIconSizeClasses.Regular,
}: ImageFileIconProps) => {
    if (!imageFilePath) {
        throw new Error("The ImageFileIcon did not receive a valid imageFilePath prop")
    }

    const altLabel = title || id || ""

    return (
        <div
            id={id}
            className={classNames(
                // relative is required to scale the nextjs image the right way, filling the container
                "relative cursor-pointer",
                iconSize,
                containerClasses
            )}
        >
            <Image
                src={imageFilePath}
                alt={altLabel}
                // just an example
                className="rounded-md"
                // depending on our use cases, consider adding the next optimizations into our props
                // currently we're only using it for the map styles bar, which needs to load right away when shown
                // will likely tweak these as we test things out in production...
                loading="eager"
                unoptimized={true}
                blurDataURL={ImagePlaceholders.BasicBlur}
                placeholder="blur"
                fill
                sizes="100vw"
                style={{
                    objectFit: "cover",
                }}
            />
        </div>
    )
}
